import React from "react";
import { Typography } from "@mui/material";
import { ExternalLink } from "components/navigation";
import { ComponentExample } from "components/examples";

const UsingCustomIcons = () => (
  <React.Fragment>
    <Typography variant="h5" gutterBottom>
      Using Custom Icons
    </Typography>
    <Typography gutterBottom>
      Custom icons (not graphics or images such as logos or backgrounds) should
      be added to projects using the{" "}
      <ExternalLink href="https://mui.com/material-ui/icons/#createsvgicon">
        createSvgIcon
      </ExternalLink>{" "}
      utility from MUI. These should still be placed within the{" "}
      <code>/assets/icons</code> folder of a project.
    </Typography>
    <Typography gutterBottom>
      The advantage of this is that the icons are then created in the same way
      as MUI&apos;s standard icons, and are fully compatible with usage in MUI
      components.
    </Typography>
    <Typography gutterBottom>When creating the icon please ensure:</Typography>
    <ul>
      <li>
        If the icon is monochromatic (has a single colour), then a{" "}
        <code>{`fill="currentColor"`}</code> attribute should be added to the
        root svg element, this allows MUI (or any other) components to apply
        their own colour as necessary, and ensures that the generated component{" "}
        <code>color</code> prop works correctly.
      </li>
      <li>
        The icon should be scaled to a 24 x 24px viewport. An easy way to check
        and achieve this is to render the icon as a React component on a page,
        and use the browser dev tools to inspect the size of it. It should be
        close to or just under 24x24px. Usually the easiest way to scale an icon
        is to add <code>{`width="24" height="24"`}</code> attributes to the svg
        tag. If this does not work, add a transform to the SVG code to achieve
        this: <code>{`transform="scale(1.5) translate(0 0)"`}</code>
      </li>
    </ul>
    <ComponentExample
      name="Custom SVG Icon"
      import={import("examples/Overview/CustomIcons/CustomSvgIconExample")}
      rawImport={import(
        "examples/Overview/CustomIcons/CustomSvgIconExample?raw"
      )}
    />
  </React.Fragment>
);

export default UsingCustomIcons;
